import o from "react";
import c from "prop-types";
import u from "dayjs";
import i from "dayjs/plugin/quarterOfYear";
import { a as l } from "./propTypes-DVvgo52A.es.js";
import { c as e, t as a, a as y } from "./utils-B8CGXZ5v.es.js";
import { u as f } from "./ThemeProvider--i7ESlT5.es.js";
import './DateRangeList.css';const D = "DateRangeList-compere-module__row___gm3fS", p = "DateRangeList-compere-module__container___QdNIH", h = "DateRangeList-compere-module__button___xmHkV", L = "DateRangeList-compere-module__label___z5D9p", x = {
  row: D,
  container: p,
  button: h,
  label: L
}, R = "DateRangeList-default-module__row___Re1dv", g = "DateRangeList-default-module__container___ly4tz", O = "DateRangeList-default-module__button___Wenra", k = "DateRangeList-default-module__label___h2XvS", m = {
  row: R,
  container: g,
  button: O,
  label: k
};
u.extend(i);
const q = {
  compere: x,
  default: m
}, S = (t) => [
  {
    text: "Last Month",
    start: a(t.clone().subtract(1, "month")),
    end: a(t.clone().subtract(1, "month"))
  },
  {
    text: "Last 3 Months",
    start: a(t.clone().subtract(3, "months")),
    end: a(t.clone().subtract(1, "month"))
  },
  {
    text: "Last Quarter",
    start: a(t.clone().subtract(1, "quarter").startOf("quarter")),
    end: a(t.clone().subtract(1, "quarter").endOf("quarter"))
  },
  {
    text: "Last 12 months",
    start: a(t.clone().subtract(12, "months")),
    end: a(t.clone().subtract(1, "month"))
  },
  {
    text: "Last Year",
    start: a(t.clone().subtract(1, "year").startOf("year")),
    end: a(t.clone().subtract(1, "year").endOf("year"))
  }
], E = (t) => [
  {
    text: "Last 7 Days",
    start: e(t.clone().subtract(7, "days")),
    end: e(t.clone().subtract(1, "days"))
  },
  {
    text: "Last Week",
    start: e(t.clone().subtract(1, "week").startOf("week")),
    end: e(t.clone().subtract(1, "week").endOf("week"))
  },
  {
    text: "Last 30 Days",
    start: e(t.clone().subtract(30, "days")),
    end: e(t.clone().subtract(1, "days"))
  },
  {
    text: "Last Month",
    start: e(t.clone().subtract(1, "month").startOf("month")),
    end: e(t.clone().subtract(1, "month").endOf("month"))
  },
  {
    text: "Last 365 Days",
    start: e(t.clone().subtract(365, "days")),
    end: e(t.clone().subtract(1, "days"))
  },
  {
    text: "Last Year",
    start: e(t.clone().subtract(1, "year").startOf("year")),
    end: e(t.clone().subtract(1, "year").endOf("year"))
  }
], d = (t) => {
  const _ = f(), n = q[_] || m;
  return /* @__PURE__ */ o.createElement("div", { className: n.container }, /* @__PURE__ */ o.createElement("div", { className: n.label }, "Date Range:"), (t.showDays ? E : S)(u()).filter(
    (s) => y(
      ...[
        t.minDate,
        s.start,
        s.end,
        t.maxDate
      ].filter((r) => r != null)
    )
  ).map(({ text: s, start: r, end: b }) => /* @__PURE__ */ o.createElement(
    "button",
    {
      key: s,
      className: n.button,
      onClick: () => t.onSelect(r, b),
      type: "button"
    },
    s
  )), t.appendElement);
};
d.propTypes = {
  onSelect: c.func.isRequired,
  showDays: c.bool.isRequired,
  minDate: l,
  maxDate: l,
  appendElement: c.node
};
d.defaultProps = {
  minDate: null,
  maxDate: null,
  appendElement: null
};
export {
  d as D
};
